const steps = (value, threshold) => Math.ceil((value - threshold) / 100);

export function localDutyPreview({ price, category, contractDate, afadStatus }) {
  const value = Number(price);
  let baseDuty;
  if (["first_new", "first_land"].includes(category) && contractDate >= "2025-05-01") baseDuty = 0;
  else if (category === "general") {
    if (value <= 5000) baseDuty = 0;
    else if (value <= 75000) baseDuty = steps(value, 5000) * 1.5;
    else if (value <= 540000) baseDuty = 1050 + steps(value, 75000) * 3.5;
    else if (value <= 1000000) baseDuty = 17325 + steps(value, 540000) * 4.5;
    else baseDuty = 38025 + steps(value, 1000000) * 5.75;
  } else {
    if (value <= 350000) baseDuty = steps(value, 0);
    else if (value <= 540000) baseDuty = 3500 + steps(value, 350000) * 3.5;
    else if (value <= 1000000) baseDuty = 10150 + steps(value, 540000) * 4.5;
    else baseDuty = 30850 + steps(value, 1000000) * 5.75;
    if (category === "first_established") {
      const band = Math.max(0, Math.min(10, Math.floor((value - 700000) / 10000)));
      baseDuty = Math.max(0, baseDuty - 1735 * (10 - band));
    }
  }
  const afad = afadStatus === "applies" ? Math.round(value * 0.08 * 100) / 100 : 0;
  return {
    dutiable_value: value, base_duty: baseDuty, afad,
    total_duty: baseDuty + afad, conditional_concession: category !== "general",
    eligibility_assessed: false, rules_version: "qld-duty-2026-09",
    rules_checked_on: "2026-09-20", source_url: "https://qro.qld.gov.au/duties/transfer-duty/calculate/",
  };
}
